import { createStore, combineReducers, applyMiddleware } from "redux";
import { thunk } from "redux-thunk";
import { composeWithDevTools } from "@redux-devtools/extension";
import {
  userReducer,
  profileReducer,
  forgotPasswordReducer,
} from "../redux/reducers/userReducers";
import { userEventsNewsReducer } from "./reducers/commonReducers";
import { contactListReducer } from "../redux/reducers/admin/contactReducer";
import { admissionReducer } from "./reducers/admin/admissionReducer";
import { eventsNewsReducer } from "./reducers/admin/eventsAndNewsReducer";
import { teacherReducer } from "./reducers/admin/teachersReducer";
import { courseReducer } from "./reducers/admin/courseReducer";
import { batchReducer } from "./reducers/admin/batchReducer";
import { studentReducer } from "./reducers/admin/studentReducer";
import { homeBannerReducer } from "./reducers/admin/homeBannerReducers";
import { galleryImageReducer } from "./reducers/admin/galleryReducer";
import { homeHighlightsReducer } from "./reducers/admin/homeHighlightsReducer";
import { aboutHighlightsReducer } from "./reducers/admin/aboutHighlightsReducer";
import {
  createAdmissionReducer,
  getAllAdmissionsReducer,
  getAdmissionByIdReducer,
  updateAdmissionReducer,
  deleteAdmissionReducer,
} from "./reducers/admissionReducers";

const reducer = combineReducers({
  user: userReducer,
  profile: profileReducer,
  forgotPassword: forgotPasswordReducer,
  contactList: contactListReducer,
  admissions: admissionReducer,
  eventsNews: eventsNewsReducer,
  userEventsNews: userEventsNewsReducer,
  teacher: teacherReducer,
  courses: courseReducer,
  batches: batchReducer,
  studentData: studentReducer,
  homeBanner: homeBannerReducer,
  gallery: galleryImageReducer,
  homeHighlights: homeHighlightsReducer,
  aboutHighlights: aboutHighlightsReducer,
  createAdmission: createAdmissionReducer,
  allAdmissions: getAllAdmissionsReducer,
  admissionDetails: getAdmissionByIdReducer,
  updateAdmission: updateAdmissionReducer,
  deleteAdmission: deleteAdmissionReducer,
});

let initialState = {};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
